import buildEditFormActionButtonsWidgetContainer from "../../../common/build-edit-form-action-buttons-widget-container"

import {
    insightAreaApplyModelUpdate,
    insightAreaCancelModelUpdate
} from "../../../../actions/insight-area-actions"

export default buildEditFormActionButtonsWidgetContainer(
    insightAreaApplyModelUpdate,
    insightAreaCancelModelUpdate,
    "insightAreas"
)
